// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"79a64a92a08cf7788113","141":"79a64a92a08cf7788113","865":"79a64a92a08cf7788113","4887":"79a64a92a08cf7788113","6153":"79a64a92a08cf7788113"}[chunkId] + ".chunk.css";
};